import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectServiceType } from "../../redux/features/customer/customerSelectors";
import { selectAreas } from "../../redux/features/country/countrySelectors";
import { selectCateringBrandsList } from "../../redux/features/restaurants/restaurantSelectors";
import { fetchAreas } from "../../redux/features/country/countryThunks";
import { getAllCateringRestaurantsAsync } from "../../redux/features/restaurants/restaurantThunks";
import { CorporateCatering } from "../../components/cateringOrder/CorporateCatering";
import { IndividualCatering } from "../../components/cateringOrder/IndividualCatering";
import AddressForm from "../../components/addAddress/addressForm";

export const CateringOrder = ({ isCheckout = false }) => {
  const dispatch = useDispatch();
  const serviceType = useSelector(selectServiceType);
  const areas = useSelector(selectAreas);
  const brandsList = useSelector(selectCateringBrandsList);

  const [cateringBrandsLoaded, setCateringBrandsLoaded] = useState(false);
  const [showAddressForm, setShowAddressForm] = useState(false);

  // Fetch areas if not already present in Redux
  useEffect(() => {
    if (!areas || areas.length === 0) {
      dispatch(fetchAreas());
    }
  }, [dispatch, areas]);

  // Fetch catering restaurants if not already loaded
  useEffect(() => {
    if (!cateringBrandsLoaded && (!brandsList || brandsList.length === 0)) {
      dispatch(getAllCateringRestaurantsAsync());
      setCateringBrandsLoaded(true);
    }
  }, [dispatch, brandsList, cateringBrandsLoaded]);


  return (
    <div className="flex flex-col gap-4 mb-3 px-4 mt-4">
      {serviceType === "corporate catering" ? (
        <CorporateCatering isCheckout={isCheckout} setShowAddressForm={setShowAddressForm} />
      ) : (
        <IndividualCatering isCheckout={isCheckout} setShowAddressForm={setShowAddressForm} />
      )}

      {/* Right Side: Address Form (Only Shows When Needed) */}
      {showAddressForm && <AddressForm setShowAddressForm={setShowAddressForm} />}
    </div>
  );
};
